import { useQuery } from "@tanstack/react-query";

import { appointmentExchangesApi } from "@/api";
import { QueryKey } from "@/query/Query";

export function useExchangeQuery() {
  return useQuery({
    queryKey: [QueryKey.AppointmentExchanges],
    queryFn: () => appointmentExchangesApi.getAppointmentExchanges(),
  });
}
